import axios from "axios";

export const baseURL =
  process.env.REACT_APP_ENV === "development"
    ? process.env.REACT_APP_API_DEV_URL
    : process.env.REACT_APP_API_URL;


export const axiosConfig = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: false,
  // timeout: 10000,
});

const axiosToken = axiosConfig;

// ✅ Intercepteur de requête : injecter le token
axiosToken.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("authToken");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// ✅ Intercepteur de réponse : gérer les erreurs d'authentification
axiosToken.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error("Erreur lors de la requête. Erreur: ", error);

    return Promise.reject(error);
  }
);

export default axiosToken;
